import api from '../../tools/api-tools'
import { mainWebPostData } from '../../config/net'
import resUrl from './resource-url'
// import './index.mock'

class AboutUser {
  index () {
    return new Promise((resolve, reject) => {
      api.get(resUrl.index).then(res => {
        let data = res.data.data || {}
        resolve(data)
      }).catch(e => {
        reject(e)
      })
    })
  }

  integral () {
    return new Promise((resolve, reject) => {
      api.post(resUrl.baseUrl, mainWebPostData(resUrl.integralInfo)).then(res => {
        let data = JSON.parse(res.data.Model)
        resolve(data)
      }).catch(e => {
        reject(e)
      })
    })
  }

  integralDetail () {
    return new Promise((resolve, reject) => {
      api.post(resUrl.baseUrl, mainWebPostData(resUrl.integralInfoDetail, 1)).then(res => {
        let model = JSON.parse(res.data.Model)
        let data = model.data || []
        let detail = []
        for (let item of data) {
          detail.push({
            title: item.ReMark,
            time: item.CreatTime,
            integral: item.FinialVal - item.OriginalVal
          })
        }
        resolve(detail)
      }).catch(e => {
        reject(e)
      })
    })
  }

  // 内敛处理
  orderListStatusType (state) {
    let type = 'order-list-status-default' // default,wait,success
    if (state.indexOf('等待') !== -1) {
      type = 'order-list-status-wait'
    } else if (state.indexOf('成功') !== -1) {
      type = 'order-list-status-success'
    }
    return type
  }

  orderList () {
    return new Promise((resolve, reject) => {
      api.post(resUrl.baseUrl, mainWebPostData(resUrl.orderList, 1)).then(res => {
        let model = JSON.parse(res.data.Model)
        let data = 'data' in model ? model.data : []
        let cellDatas = []
        for (let item of data) {
          cellDatas.push(this.orderListItemObj(item))
        }
        resolve(cellDatas)
      }).catch(e => {
        reject(e)
      })
    })
  }

  // 订单列表单条数据结构
  orderListItemObj (originOrderItem) {
    return {
      orderId: originOrderItem.Oid,
      orderNum: originOrderItem.OrderNo,
      orderTitle: originOrderItem.BusDesc,
      orderQuantity: originOrderItem.BusQuantity,
      orderStatus: originOrderItem.OrderStatusDesc,
      orderStatusType: this.orderListStatusType(originOrderItem.OrderStatusDesc),
      orderIcon: originOrderItem.GoodsImagePath,
      orderPayType: originOrderItem.OrderPayType,
      orderPayTypeDesc: originOrderItem.OrderPayTypeDesc,
      totalPrice: originOrderItem.RealPayMoney,
      shoppingDate: originOrderItem.CreateDate,
      isRepay: originOrderItem.IsMenuRePay,
      originOrderItem
    }
  }

  // 改变订单条目支付状态
  orderItemChangeStatus (originOrderItem) {
    originOrderItem.OrderStatusDesc = '支付成功'
    originOrderItem.IsMenuRePay = false
    return this.orderListItemObj(originOrderItem)
  }
}

export default AboutUser



// WEBPACK FOOTER //
// ./src/model/about-user/index.js